import { useCallback } from 'react';
import { BlacklistRequest } from '../../../../../store/reducers/BlacklistSlice';
import { ReasonTypes } from '../../types';

interface Props {
  onCallRequest: (value: BlacklistRequest) => void;
  callRequest: BlacklistRequest;
}

export const useBlacklistFilterChanges = ({
  onCallRequest,
  callRequest,
}: Props) => {
  const handleReason = useCallback(
    (e: ReasonTypes | null) => {
      console.log('HANDLE', e);
      onCallRequest({
        ...callRequest,
        Reason: e,
      });
    },
    [onCallRequest, callRequest],
  );

  return {
    handleReason,
  };
};
